import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LayoutService {

    private headerDisabled = false;
    private headerRef;
    private footerDisabled = true;

    constructor() { }

    public setHeader(header) {
        this.headerRef = header;
    }

    public disableHeader() {
        if (this.headerRef) {
            try {
                this.headerRef.hide();
                this.headerDisabled = true;
            } catch (e) {
                console.warn('Missing header reference');
            }
        }
    }
    public enableHeader() {
        if (this.headerRef) {
            try {
                this.headerRef.show();
                this.headerDisabled = false;
            } catch (e) {
                console.warn('Missing header reference');
            }
        }
    }
    public isHeaderDisabled() {
        return this.headerDisabled;
    }

    public disableFooter() {
        this.footerDisabled = true;
    }
    public enableFooter() {
        this.footerDisabled = false;
    }
    public isFooterDisabled() {
        return this.footerDisabled;
    }
}
